import { createContext, useState, useEffect } from 'react';

/**
 * ExpirationTickerContext
 *
 * Global ticker pattern for expiration timers.
 * Single setInterval broadcasts current time to all subscribers.
 * Prevents performance degradation with 100+ NFTs by using 1 timer instead of N timers.
 */
const ExpirationTickerContext = createContext(null);

/**
 * ExpirationTickerProvider
 *
 * Provides a global ticker that updates every second.
 * All expiration countdown components subscribe to this single ticker.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Child components
 * @returns {JSX.Element}
 */
export function ExpirationTickerProvider({ children }) {
  const [currentTime, setCurrentTime] = useState(() => Math.floor(Date.now() / 1000));

  useEffect(() => {
    // Update every second (1000ms)
    const interval = setInterval(() => {
      setCurrentTime(Math.floor(Date.now() / 1000));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <ExpirationTickerContext.Provider value={{ currentTime }}>
      {children}
    </ExpirationTickerContext.Provider>
  );
}

export default ExpirationTickerContext;
